/* istanbul ignore file */
import { BaseFieldLayoutType, useFieldHelper } from 'framework/ui/field';
import { Button } from 'framework/ui/mui-builder';
import { BpmnDiagramService } from 'domain/gpo/cockpit/facade/useBpmnJs';
import { useUiTheme } from 'framework/uiTheme';
import { CopyToClipboardButton } from 'framework/ui/clipboard';

interface Props {
  label?: string;
  activitySource: string;
  executionSource: string;
  bpmnJs?: BpmnDiagramService;
  setHighlightedItem: (item: { executionId: string; activityId: string }) => any;
}
const ActivityIdField = ({ activitySource, executionSource, bpmnJs, setHighlightedItem, label }: Props) => {
  const { getValue: getActivityId } = useFieldHelper({ source: activitySource });
  const { getValue: getExecutionId } = useFieldHelper({ source: executionSource });
  const { BaseFieldLayout } = useUiTheme<BaseFieldLayoutType>();

  const activityId = getActivityId();
  const executionId = getExecutionId();
  const onClick = () => {
    const item = {
      executionId,
      activityId,
    };
    setHighlightedItem(item);
    bpmnJs?.zoomToElement(activityId);
    bpmnJs?.getDiagramElement().scrollIntoView({ block: 'center', behavior: 'smooth' });
  };

  const button = (
    <>
      <Button
        link
        variant="outlined"
        onClick={onClick}
        sx={{ padding: '0 !important', userSelect: 'auto !important', marginRight: '5px' }}
      >
        {activityId}
      </Button>
      <CopyToClipboardButton value={activityId} id={activityId} className="activity-copy-link">
        Copy Activity ID
      </CopyToClipboardButton>
    </>
  );

  return <BaseFieldLayout label={label} value={button} />;
};

export default ActivityIdField;
